module.exports = __webpack_public_path__ + "static/img/withoutAny.ca6e7d6c.png";